import Vue from 'vue'
import disableOnRequests from '@/shared/directives/disableOnRequests'
import uppercase from '@/shared/directives/uppercase'

Vue.directive('disableOnRequests', disableOnRequests)
Vue.directive('uppercase', uppercase)
